import React, { FunctionComponent } from 'react';

import SingleRead from '../../SingleRead/SingleRead';
import styles from './SingleCategory.module.scss';

interface Props {
  articlesInCategory?: Article[];
}

const SingleCategory: FunctionComponent<Props> = ({ articlesInCategory }) => {
  return (
    <>
      <div className={styles.category}>
        {articlesInCategory && articlesInCategory.length > 0 ? (
          articlesInCategory.map((item: Article) => (
            <div className={styles.articleWrapper} key={item.id}>
              <SingleRead article={item} showHeroImage={true} />
            </div>
          ))
        ) : (
          <div>There are no articles in this topic!</div>
        )}
      </div>
    </>
  );
};

export default SingleCategory;
